module.exports = __webpack_public_path__ + "static/media/logo_access.c574cafb.png";